import { AccountCircle } from "@mui/icons-material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import MenuIcon from "@mui/icons-material/Menu";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import { Box, Chip, Tooltip, useMediaQuery } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import { styled, useTheme } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import React from "react";
import { NavLink } from "react-router-dom";
import AuthService from "../../../AuthService";
import StatusLoja from "./StatusLoja";
import Logo from "../../../imagens/logo-qrpedir";
import AppTrialPeriod from "./AppTrialPeriod";
import Hidden from "../../Hidden";
import imagemFundo from "../../../imagens/1234.png";

const drawerWidth = 270;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,

  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),

  variants: [
    {
      props: ({ open }) => open,

      style: {
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

export default function AppHeader({
  open,
  onOpen,
  setOpenTutorial,
  openTutorial,
  isTemporaria,
  empresa,
  identificadorDelivery,
  openTesteApp,
  setOpenTesteApp,
}) {
  const auth = new AuthService();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const nomeUsuario = JSON.parse(localStorage.getItem("_profile"))?.nome;

  const handleDrawerOpen = () => onOpen();

  const toogleTesteApp = () => {
    const updated = !openTesteApp;
    setOpenTesteApp(updated);
    localStorage.setItem("_TESTE_APP_", updated);
  };
  return (
    <AppBar>
      <AppTrialPeriod
        isTemporaria={isTemporaria}
        empresa={empresa}
        setOpenTutorial={setOpenTutorial}
        openTutorial={openTutorial}
      />
      <AppBar
        position="fixed"
        sx={[
          {
            backgroundImage: `url(${imagemFundo})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            zIndex: theme.zIndex.drawer + 1,
            backgroundPosition: "center",

            transition: theme.transitions.create(["width", "margin"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          },

          open
            ? isMobile
              ? {
                  width: "0rem",
                }
              : {
                  width: `calc(100% - ${drawerWidth}px)`,
                }
            : {
                width: "100vw",
              },

          isTemporaria
            ? {
                marginTop: "40px",
              }
            : {
                marginTop: "0px",
              },
        ]}
      >
        <Toolbar style={{ padding: "0 0.6rem " }} margin="0rem">
          <Box display="flex" alignItems="center" justifyContent="center">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              size="large"
            >
              {open ? <ChevronLeftIcon /> : <MenuIcon />}
            </IconButton>
          </Box>
          <Typography
            variant="h6"
            noWrap
            style={{
              fontFamily: "Bebas Neue",
              fontWeight: 500,
              marginLeft: "1rem",
            }}
          >
            Station
          </Typography>

          {auth.isAdmin() && empresa?.representante && (
            <Box pl={1}>
              <Chip
                label={empresa.representante}
                color="secondary"
                style={{
                  fontFamily: "Bebas Neue",
                  fontWeight: 500,
                  fontSize: "20px",
                }}
              />
            </Box>
          )}

          <Box sx={{ flexGrow: 1, textAlign: "center" }}>
            <Hidden mdDown implementation="css">
              <Logo
                style={{ width: "100px", height: "auto" }}
                alt="Logo qrpedir"
              />
            </Hidden>
          </Box>

          {auth.loggedIn() ? (
            <>
              {identificadorDelivery && (
                <Hidden mdDown implementation="css">
                  <Tooltip title="Mostrar app">
                    <IconButton
                      onClick={toogleTesteApp}
                      color="inherit"
                      size="large"
                    >
                      <SmartphoneIcon />
                    </IconButton>
                  </Tooltip>
                </Hidden>
              )}
              <StatusLoja />
              <Tooltip title={nomeUsuario}>
                <IconButton color="inherit" size="large">
                  <AccountCircle />
                </IconButton>
              </Tooltip>
            </>
          ) : (
            <NavLink to="/Login" sx={{ color: "#ffffff !important" }}>
              <span>Acessar</span>
            </NavLink>
          )}
        </Toolbar>
      </AppBar>
    </AppBar>
  );
}
